import { useAppDispatch } from "../../../hooks/store-hooks";
import {
  Certificate,
  Currency,
  GoldenCalender,
  GraduationCap,
  LiveStream,
  MembershipBadge,
  PieChart,
} from "../../../icons";
import { closeModal } from "../../../store/slices/modalSlice";
import Modal from "../modals";
import BecomeMemberButton from "./BecomeMemberButton";

const features = [
  {
    icon: GraduationCap,
    heading: "Money School",
    content:
      "Learning modules by top creators. Everything you need to know about personal finance, stock market, credit cards.",
  },
  {
    icon: Certificate,
    heading: "Bootcamp",
    content:
      "A structured and gamified learning experience curated by a mentor who gets you.",
  },
  {
    icon: PieChart,
    heading: "Financial Tools",
    content:
      "Customise your path to financial freedom by using proprietary financial planning tools.",
  },
  {
    icon: Currency,
    heading: "Save More",
    content: "Save more by using ONE coins and get discounts on big brands.",
  },
  {
    icon: GoldenCalender,
    heading: "1% Experiences",
    content:
      "Attend Offline events and build your network by meeting amazing people.",
  },
  {
    icon: LiveStream,
    heading: "Livestreams",
    content:
      "Be a part of weekly livestreams and keep updating yourself and learn more with the 1% Club.",
  },
];

const Card = ({
  icon,
  heading,
  content,
}: {
  icon: any;
  heading: string;
  content: string;
}) => {
  return (
    <div className="p-4 flex flex-col bg-[#252525] rounded-[10px] border border-neutral-700 gap-1">
      {icon()}
      <div className="text-white text-xl font-['SF Pro'] leading-6">
        {heading}
      </div>
      <div className="text-[#cdcdcd] text-md font-normal font-['SF Pro'] leading-tight">
        {content}
      </div>
    </div>
  );
};

const BecomeMember = () => {
  const dispatch = useAppDispatch();
  return (
    <Modal isOpen customClass="bg-primary-900 rounded-2xl ">
      <div className="flex flex-col items-center p-4 gap-6">
        <div className="flex justify-center items-center">
          <MembershipBadge />{" "}
          <div className="text-[34px] font-normal font-['SF Pro'] leading-10 tracking-wide bg-gradient-text text-transparent bg-clip-text">
            Become a Member of 1% Club
          </div>
        </div>

        <div className="grid grid-cols-3 grid-rows-2 gap-2">
          {features.map((feature) => (
            <Card {...feature} />
          ))}
        </div>

        <BecomeMemberButton />
        <button
          type="button"
          onClick={() => {
            dispatch(closeModal());
          }}
          className="text-neutral-500 text-sm -mt-4"
        >
          No, thanks.
        </button>
      </div>
    </Modal>
  );
};

export default BecomeMember;
